<template>
  <div class="filters-container" v-click-outside="hide">
    <div class="filters-container__content">
      <div class="filters-list">
        <div class="container-inputs__inputs">
          <span :class="validateFieldInfo(filtersData.company_name) ? 'active' : ''">
            <i class="ion ion-person-circle-outline mr-1"></i>
            Company Name
          </span>
          <div class="input-container">
            <input v-model="filtersData.company_name" type="text" class="input-information" />
          </div>
        </div>
        <div class="container-inputs__inputs">
          <span :class="validateFieldInfo(filtersData.account_email) ? 'active' : ''">
            <i class="ion ion-mail-outline mr-1"></i>
            Account Email
          </span>
          <div class="input-container">
            <input v-model="filtersData.account_email" type="text" class="input-information" />
          </div>
        </div>
        <div class="container-inputs__inputs">
          <span :class="validateFieldInfo(filtersData.api_key) ? 'active' : ''">
            <i class="ion ion-key-outline mr-1"></i>
            Api Key
          </span>
          <div class="input-container">
            <input v-model="filtersData.api_key" type="text" class="input-information" />
          </div>
        </div>
        <div class="container-inputs__inputs">
          <span :class="validateFieldInfo(filtersData.webhook_link) ? 'active' : ''">
            <i class="ion ion-link-outline mr-1"></i>
            Webhook Link
          </span>
          <div class="input-container">
            <input v-model="filtersData.webhook_link" type="text" class="input-information" />
          </div>
        </div>
        <div class="container-inputs__status">
          <div class="" v-for="(item, index) in filterInformation" :key="item.text">
            <span  :class="validateFieldInfoToggle(filterInformation[index].value) ? 'active' : ''">{{ item.text }}</span>
            <ToggleSelector
              :name="item.item"
              :index="index"
              :value="item.value"
              v-model="item.value"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="button-container">
      <button class="button-container__button" @click="applyFilters()">Apply</button>
      <button class="button-container__button" @click="resetFilters()">Reset</button>
      <button class="button-container__button" @click="$emit('closeFilters')">Close</button>
    </div>
  </div>
</template>

<script>
import ClickOutside from "../../../../directives/ClickOutside";
import ToggleSelector from "../../../AccountManagement/components/ToggleSelector.vue";

export default {
  name: "FilterAccount",
  props: {
    savedFilters: Object,
  },
  data() {
    return {
      triggerOpenedFilters: true,
      checkedFilters: [],
      filtersData: {
        company_name: "",
        account_email: "",
        api_key: "",
        webhook_link: "",
        is_active: null,
        webhook_is_active: null,
      },
      filterInformation: [
        {
          item: "is_active", text: "Status", field: "is_active", value: "n/a"
        },
        {
          item: "webhook_is_active", text: "Webhook Active", field: "webhook_is_active", value: "n/a",
        }
      ],
    };
  },
  directives: {
    "click-outside": ClickOutside,
  },
  components: {
    ToggleSelector,
  },
  computed: {
    validateFieldInfo() {
      return (data) => {
        if (typeof data === "string") {
          return data.trim();
        }
        return data;
      };
    },
    validateFieldInfoToggle() {
      return (data) => {
        if (data === 'off' || data === 'on') {
          return true;
        }
        return false;
      };
    },
  },
  created() {
    if (this.savedFilters) {
      this.filtersData = this.savedFilters;
      this.filterInformation = this.filterInformation.map((item) => {
        const value = this.filtersData[item.field];
        return {
          ...item,
          value: this.transformStatus([{ value }], "toString")[0].value
        };
      });
    }
  },

  methods: {
    hide() {
      if (this.triggerOpenedFilters) {
        this.triggerOpenedFilters = false;
        return;
      }
      this.$emit("closeFilters");
    },
    applyFilters() {
      this.filterInformation = this.transformStatus(this.filterInformation, "toBoolean");

      this.filtersData.is_active = this.filterInformation.find((i) => i.field === "is_active").value;
      this.filtersData.webhook_is_active = this.filterInformation.find((i) => i.field === "webhook_is_active").value;

      this.$emit("selectedFilters", { filters: this.filtersData });
      this.hide();
    },
    resetFilters() {
      this.filtersData = {
        company_name: "",
        account_email: "",
        api_key: "",
        webhook_link: "",
        is_active: null,
        webhook_is_active: null
      };
      this.filterInformation = [
        {
          item: "is_active", text: "Status", field: "is_active", value: "n/a"
        },
        {
          item: "webhook_is_active", text: "Webhook Active", field: "webhook_is_active", value: "n/a"
        },
      ];
      this.$emit("resetFilters");
    },
    transformStatus(data, direction = "toBoolean") {
      return data.map((item) => {
        let { value } = item;
        if (direction === "toBoolean") {
          if (value === "off") value = false;
          else if (value === "on") value = true;
          else value = null;
        } else if (value === false) value = "off";
        else if (value === true) value = "on";
        else value = "n/a";
        return { ...item, value };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/_themes' as *;
@use '@/assets/scss/_variables' as *;
@use '@/assets/scss/_mixin' as *;
@use '@/assets/scss/inputs/_inputs' as *;
.filters-container {
  &__content {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 7px;
  }
}

.filters-list {
  background: #efefef;
  border-radius: 5px;
  padding: 6px;
  &:nth-child(1) {
    min-width: 230px;
  }
}
.active {
  color: $color-border-container !important;
}
.button-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  &__button {
    border-radius: 15px;
    border: 1px solid $color-border-container;
    background-color: #fff;
    color: $color-border-container;
    margin: 2px;
    font-weight: bold;
    height: 25px;
    width: 70px;
    font-size: 11px;
    &:hover {
      background: $color-border-container;
      color: white;
    }
  }
}
.dates-container {
  display: flex;
  flex-direction: column !important;
}
.container-inputs {
  &__inputs {
    flex-direction: row;
    margin-bottom: 8px;
    span {
      display: flex;
      align-items: center;
      color: #606266;
      font-size: 11px;
    }
    i {
      font-size: 13px;
    }
  }
  &__titles {
    font-size: 11px;
    font-family: $font-family-portal;
    color: #606266;
  }
  &__titles-active {
    font-size: 11px;
    font-family: $font-family-portal;
    color: $color-border-container;
  }
  &__status {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    span {
      display: flex;
      align-items: center;
      color: #606266;
      font-size: 11px;
    }
  }
}
.input-container {
  @include input-information;
  border: 1px solid #fff;
  color: $color-primary-company;
  padding: 7px 0px 5px 5px;
  height: 25px;
  box-shadow: none;
  margin: 0px;
  font-family: $font-family-portal;
  border-radius: 5px;
  &:hover {
    box-shadow: none;
  }
  &:focus-within {
    box-shadow: none;
  }
}
.input-information {
  @include input-password;
  width: 100%;
  font-size: 11px;
  color: #606266;
}
.selector-list ::v-deep .el-input__inner {
  width: 100%;
  height: 30px;
}
::v-deep {
  .el-input__inner {
    border-radius: 5px;
    border: 1px solid #efefef;
    box-sizing: border-box;
    color: #606266;
    height: 25px;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    font-family: "Montserrat";
    font-size: 11px;
    width: 140px;
  }
  .el-input__prefix,
  .el-input__suffix {
    top: -5px;
  }
  .el-date-editor.el-input {
    width: auto;
    &.missing-field input {
      border: 1px solid red !important;
    }
  }
  .el-input__icon {
    height: auto;
  }
  .el-select {
    width: none;
  }
  .el-input--suffix {
    width: 100%;
  }
  .el-select {
    width: 100% !important;
  }
  .el-input.is-focus .el-input__inner {
    border: none !important;
  }
}
</style>
